import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BLink } from "bootstrap-vue";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionCreatorNoItemsMessage',
    emits: ["click-upload"],
    setup(__props, { emit }) {
        return { __sfc: true, emit, BAlert, BLink, localize };
    }
});
